import styled from 'styled-components';

import { COMMUNICATION_CHANNEL_COLORS, COMMUNICATION_CHANNEL_GRADIENTS } from 'constants/communicationTags';

export const FollowUpTable = styled.div`
  border-left: 3px solid var(--lavender-purple);
  padding-left: 12px;
  background: var(--white);
`;

export const FollowUpRow = styled.div<{ isPrimary?: boolean }>`
  display: grid;
  grid-template-columns: 38px minmax(145px, 210px) minmax(150px, 1fr) 50px;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 3px 0;
  border-bottom: 1px solid var(--line-gray);
  background: ${({ isPrimary }) => (isPrimary ? 'var(--lavender-pale)' : 'transparent')};

  @media (max-width: 650px) {
    grid-template-columns: 30px minmax(110px, 1fr) 44px;
  }
`;

export const FollowUpHeading = styled(FollowUpRow)`
  min-height: 30px;
  color: var(--text-secondary);
  font-size: 12px;
  font-family: var(--font-regular);
`;

export const ChannelBar = styled.div`
  display: flex;
  height: 10px;
  overflow: hidden;
  border-radius: 5px;
  background: var(--lighter-gray);
`;

export const ChannelSegment = styled.button<{ channel: string; isTerminal: boolean; width: number }>`
  width: ${({ width }) => `${width}%`};
  padding: 0;
  border: 0;
  border-radius: ${({ isTerminal }) => (isTerminal ? '0 5px 5px 0' : '0')};
  background: ${({ channel }) =>
    COMMUNICATION_CHANNEL_GRADIENTS[channel] ?? COMMUNICATION_CHANNEL_COLORS[channel] ?? 'var(--text-secondary)'};
  cursor: pointer;

  &:disabled {
    cursor: default;
  }

  &:focus-visible {
    position: relative;
    z-index: 1;
    outline: 2px solid var(--dark-blue);
    outline-offset: -2px;
  }
`;

export const ChannelLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 14px;
  margin-top: 12px;
  color: var(--text-secondary);
  font-size: 12px;
`;

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;

export const LegendDot = styled.span<{ channel: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ channel }) => COMMUNICATION_CHANNEL_COLORS[channel] ?? 'var(--text-secondary)'};
`;

export const SequenceGrid = styled.div`
  display: grid;
  grid-template-columns: 38px minmax(150px, 210px) repeat(7, minmax(28px, 1fr)) 80px;
  align-items: center;
  gap: 8px;
  min-width: 740px;
`;

export const SequenceScroll = styled.div`
  overflow-x: auto;
`;

export const SequenceHeading = styled(SequenceGrid)`
  min-height: 30px;
  color: var(--text-secondary);
  font-size: 12px;
  font-family: var(--font-regular);
  border-bottom: 1px solid var(--line-gray);
`;

export const SequenceDayHeading = styled.div`
  text-align: center;
`;

export const FollowUpTouches = styled.div`
  padding-right: 16px;
  font-family: var(--font-bold);
  text-align: right;
`;

export const SequenceRow = styled(SequenceGrid)<{ isPrimary?: boolean }>`
  min-height: 52px;
  padding: 3px 0;
  border-bottom: 1px solid var(--line-gray);
  background: ${({ isPrimary }) => (isPrimary ? 'var(--lavender-pale)' : 'transparent')};
`;

export const SequenceDay = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3px;
`;

export const SequenceDot = styled.button<{ channel: string }>`
  width: 10px;
  height: 10px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: ${({ channel }) => COMMUNICATION_CHANNEL_COLORS[channel] ?? 'var(--text-secondary)'};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--dark-blue);
    outline-offset: 2px;
  }
`;
